/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function PublicCardView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        border: '1px solid var(--pub-line)',
        borderRadius: '18px',
        padding: '24px 26px',
        background: 'linear-gradient(135deg, var(--pub-a) 0%, var(--pub-b) 46%, var(--pub-c) 100%)',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,300px),1fr))',
        gap: '24px',
        alignItems: 'start',
      }}
    >
      {' '}
      <div style={{ minWidth: '0' }}>
        {' '}
        <div
          style={{
            fontSize: '9px',
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: 'var(--pub-dim)',
            fontWeight: '600',
          }}
        >
          {dc.t(m.pfVerified)}
        </div>{' '}
        <div
          style={{
            fontSize: '24px',
            fontWeight: '500',
            letterSpacing: '-0.02em',
            color: 'var(--pub-ink)',
            marginTop: '10px',
          }}
        >
          {dc.t(m.pfTraderName)}
        </div>{' '}
        <div style={{ fontSize: '14px', color: 'var(--pub-accent)', marginTop: '4px' }}>Verified Trader</div>{' '}
        <div
          style={{
            fontSize: '11.5px',
            color: 'var(--pub-dim)',
            lineHeight: '1.6',
            marginTop: '12px',
            maxWidth: '44ch',
          }}
        >
          {dc.t(m.pfPublicSub)}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,140px),1fr))',
            gap: '20px',
            marginTop: '20px',
            padding: '16px 18px',
            borderRadius: '14px',
            border: '1px solid var(--pub-line)',
            background: 'var(--pub-glass)',
          }}
        >
          {' '}
          <div>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                color: 'var(--pub-dim)',
                fontWeight: '600',
              }}
            >
              Composite P&L
            </div>
            <div
              style={{
                fontSize: '19px',
                fontWeight: '500',
                color: 'var(--pub-ink)',
                marginTop: '6px',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.pfPublicPnl)}
            </div>
          </div>{' '}
          <div>
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                color: 'var(--pub-dim)',
                fontWeight: '600',
              }}
            >
              Win rate
            </div>
            <div
              style={{
                fontSize: '19px',
                fontWeight: '500',
                color: 'var(--pub-ink)',
                marginTop: '6px',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.pfPublicWr)}
            </div>
            <div
              style={{
                fontSize: '10px',
                color: 'var(--pub-dim)',
                marginTop: '2px',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.pfPublicWrSub)}
            </div>
          </div>{' '}
        </div>{' '}
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '10.5px',
            padding: '5px 13px',
            borderRadius: '99px',
            border: '1px solid color-mix(in srgb, var(--pub-accent) 40%, transparent)',
            background: 'color-mix(in srgb, var(--pub-accent) 14%, transparent)',
            color: 'var(--pub-accent)',
            marginTop: '20px',
          }}
        >
          {dc.t(m.pfTierChip)}
        </span>{' '}
      </div>{' '}
      <div style={{ minWidth: '0', textAlign: 'right' }}>
        {' '}
        <div
          style={{
            fontSize: '9px',
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: 'var(--pub-dim)',
            fontWeight: '600',
          }}
        >
          PointFive Score
        </div>{' '}
        <div
          style={{
            fontSize: '56px',
            fontWeight: '600',
            letterSpacing: '-0.04em',
            lineHeight: '1.05',
            color: 'var(--pub-accent)',
            marginTop: '6px',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {dc.t(m.pfScore)}
        </div>{' '}
        <div style={{ fontSize: '14px', color: 'var(--pub-ink)', marginTop: '4px' }}>
          {dc.t(m.pfPublicGrade)}
        </div>{' '}
        <div
          style={{
            display: 'flex',
            gap: '7px',
            justifyContent: 'flex-end',
            marginTop: '12px',
            flexWrap: 'wrap',
          }}
        >
          {' '}
          {(m.pfPublicChips ?? []).map((c, i211) => (
            <Fragment key={i211}>
              <span
                style={{
                  fontSize: '10px',
                  padding: '4px 11px',
                  borderRadius: '99px',
                  background: 'var(--pub-glass)',
                  border: '1px solid var(--pub-line)',
                  color: 'var(--pub-ink)',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {dc.t(c?.label)}
              </span>
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ fontSize: '10px', color: 'var(--pub-dim)', marginTop: '36px' }}>
          {dc.t(m.pfPublicSlug)}
        </div>{' '}
      </div>{' '}
    </div>
  );
}
